var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLayerGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-layer-group",
    "data-name": "Icon awesome-layer-group",
    d: "M.533,6.36,10.542,10.9a1.1,1.1,0,0,0,.915,0L21.466,6.36a.96.96,0,0,0,0-1.72L11.458.1a1.1,1.1,0,0,0-.915,0L.533,4.64a.96.96,0,0,0,0,1.72Zm20.933,3.793-2.5-1.131L12.025,12.17a2.477,2.477,0,0,1-2.05,0L3.03,9.022l-2.5,1.131a.959.959,0,0,0,0,1.719l10.009,4.537a1.1,1.1,0,0,0,.915,0l10.01-4.537a.959.959,0,0,0,0-1.719Zm0,5.491L18.98,14.518,12.025,17.67a2.477,2.477,0,0,1-2.05,0L3.02,14.518.533,15.645a.959.959,0,0,0,0,1.719L10.542,21.9a1.1,1.1,0,0,0,.915,0l10.01-4.537a.959.959,0,0,0,0-1.719Z",
    transform: "translate(0 0.001)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayerGroup);
export default __webpack_public_path__ + "static/media/layer-group.5a8d4c0c5834a9bc1cfb416ba81ccfc6.svg";
export { ForwardRef as ReactComponent };